import React from 'react';
import { PageHeader } from '../../../shared/components/patterns';

function ClientsHeader() {
  return (
    <PageHeader
      title="Clienti"
      description="Gestisci la tua base clienti e le relazioni commerciali"
    />
  );
}

export default ClientsHeader;
